import React from "react"
import ArticlesWithWidgets from "./articles-with-widgets"
import ArticlesSuggestions from "./articles-suggestions"
import Characters from "./characters"
import FullWidthBanners from "./full-width-banners"
import FullWidthSlider from "./full-width-slider"
import InfoBox from "./info-box"
import Media from "./media"
import SliderWithWidgets from "./slider-with-widgets"
import ToggleBox from "./toggle-box"
import FullSizeSlider from "./full-size-slider"
import NotFullWidthBanners from "./not-full-width-banners"
import GameList from "./game-list"
import VerticalGamingNews from "./vertical-gaming-news"
import TextSection from "./text-section"
import { IAllNews } from "../../gatsby-graphql"
import HorizontalNews from "./horizontal-news"
import FullWidthVideo from "./full-width-video"
import HighlightedNews from "./highlighted-news"

export interface SectionProps {
  locale?: string
}

interface SectionLoaderProps extends SectionProps {
  data: any
}

const SectionLoader = ({ data, locale }: SectionLoaderProps) => {
  switch (data.strapi_component) {
    case "sections.articles-with-widgets":
      return <ArticlesWithWidgets data={data} locale={locale} />
    case "sections.articles-suggestions":
      return <ArticlesSuggestions data={data} locale={locale} />
    case "sections.characters":
      return <Characters data={data} locale={locale} />
    case "sections.full-width-banners":
      return <FullWidthBanners data={data} locale={locale} />
    case "sections.games-list":
      return <GameList data={data} locale={locale} />
    case "sections.not-full-width-banners":
      return <NotFullWidthBanners data={data} locale={locale} />
    case "sections.full-width-slider":
      return <FullWidthSlider data={data} locale={locale} />
    case "sections.info-box":
      return <InfoBox data={data} locale={locale} />
    case "sections.media":
      return <Media data={data} locale={locale} />
    case "sections.slider-with-widgets":
      return <SliderWithWidgets data={data} locale={locale} />
    case "sections.toggle-box":
      return <ToggleBox data={data} locale={locale} />
    case "sections.full-size-slider":
      return <FullSizeSlider data={data} locale={locale} />
    case "sections.text-section":
      return <TextSection data={data} locale={locale} />
    case "sections.item-list":
      return <div>Not implemented</div>
    case "sections.all-news":
      return <HorizontalNews data={data} locale={locale} />
    case "sections.vertical-gaming-news":
      return <VerticalGamingNews data={data} locale={locale} />
    case "sections.full-width-video":
      return <FullWidthVideo data={data} locale={locale} />
    case "sections.highlighted-news":
      return <HighlightedNews data={data} locale={locale} />
    default:
      return <></>
  }
}

export default SectionLoader
